// Using the client-side compatible version that doesn't rely on Node.js modules
import createDOMPurify from 'dompurify';
const DOMPurify = createDOMPurify(window);

export const ALLOWED_TAGS = [
  // Headers
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  // Text formatting
  'p',
  'div',
  'span',
  'pre',
  'br',
  'strong',
  'em',
  'u',
  'strike',
  'sub',
  'sup',
  // Lists
  'ul',
  'ol',
  'li',
  // Links
  'a',
  // Tables
  'table',
  'thead',
  'tbody',
  'tr',
  'td',
  'th',
  // Images
  'img',
];

export const ALLOWED_ATTRIBUTES = {
  '*': ['class', 'style', 'id'],
  a: ['href', 'target', 'rel'],
  img: ['src', 'alt', 'width', 'height'],
};

export const ALLOWED_STYLES = {
  '*': {
    color: [/^#[0-9a-f]{3,6}$/i, /^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/],
    'text-align': [/^left$/, /^right$/, /^center$/, /^justify$/],
    'background-color': [/^#[0-9a-f]{3,6}$/i, /^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/],
    'font-size': [/^\d+(?:px|em|%)$/],
    margin: [/^\d+(?:px|em|%)$/],
    padding: [/^\d+(?:px|em|%)$/],
  },
};

export const sanitizeRichText = html => {
  // Use DOMPurify instead of sanitize-html to avoid Node.js modules in browser
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: Object.entries(ALLOWED_ATTRIBUTES).flatMap(([tag, attrs]) =>
      tag === '*' ? attrs : attrs.map(attr => `${tag}::${attr}`)
    ),
    ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|file):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
    ADD_TAGS: ALLOWED_TAGS,
    ADD_ATTR: Object.entries(ALLOWED_ATTRIBUTES).flatMap(([tag, attrs]) =>
      tag === '*' ? attrs : attrs.map(attr => `${tag}::${attr}`)
    ),
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'script'],
    FORBID_ATTR: ['style', 'onerror', 'onload'],
  });
};
